/* eslint-disable */
import React, { useState, useEffect, useRef, useContext } from 'react';
import {
  Box,
  IconButton,
  TextField,
  Button,
  OutlinedInput,
  InputAdornment,
  Menu,
  MenuItem,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '../../../../../Assets/images/svg/dar_delete.svg';
import RemoveIcon from '@mui/icons-material/Remove';
import styles from './scopeFE.module.scss';
import Dar_Edit from '../../../../../Assets/images/svg/dar_edit.svg';
import Dar_noFile from '../../../../../Assets/images/svg/dar_no_new_file.svg';
import SettingsDropdown from '../../../../../Assets/images/svg/dar_selected_master.svg';
import DropdownArrow from '../../../../../Assets/images/svg/dar_drop_down_arrow.svg';
import { useSnackbar } from '../../../../../Components/Snackbar/snackBarProvider';
import MagnifyingGlass from '../../../../../Assets/images/svg/dar_magnifying.svg';
import PropTypes from 'prop-types';
import BulkUpdate from './BulkUpdate/bulkUpdate';
import FilterPanel from '../ScopeBE/filterPanel';
import { AuthContext } from '../../../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../../../Constants/modules';
import UseAxios from '../../../../../Api/http/http';
import {
  saveFEeffortDetails,
  getBaseEffort,
  getRequirementClarity,
  getTechnicalComplexity,
  getExternalIntegration,
  getCalculatedFeBaseEffort,
  getFEeffortDetails,
  editFEeffortDetails,
} from '../../../../../Api/request/dealEffort';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../../../../../Components/Loader';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandedContent from './expandedContent';
import StoryIcon from '../../../../../Assets/images/svg/dar_story_icon.svg';
import EpicIcon from '../../../../../Assets/images/svg/dar_epic_icon.svg';
import SubStoryIcon from '../../../../../Assets/images/svg/dar_sub_task.svg';
import SettingIcon from "../../../../../Assets/images/svg/dar_more_icon.svg";


const ExpandButton = ({ id, expanded, onToggleExpand }) => {
  return (
    <IconButton onClick={() => onToggleExpand(id)}>
      <img
        src={DropdownArrow}
        alt="Expand/Collapse"
        style={{ transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)' }}
      />
    </IconButton>
  );
};

const getTypeIcon = (type) => {
  const iconStyles = {
    Epic: { justifyContent: 'flex-start' },
    Story: { justifyContent: 'center' }, 
    'Sub-Story': { justifyContent: 'flex-end' }, 
  };

  const iconSrc = {
    Epic: EpicIcon,
    Story: StoryIcon,
    'Sub-Story': SubStoryIcon,
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%', ...iconStyles[type] }}>
      <img src={iconSrc[type]} alt={type} style={{ width: 20, height: 20 }} />
    </div>
  );
};

export default function ExpandableDataGrid() {
  const [expandedRows, setExpandedRows] = useState([]);
  const [isFilterPanelVisible, setIsFilterPanelVisible] = useState(false);
  const [rows, setRows] = useState([]);
  const [isEditing, setIsEditing] = useState({});
  const topScrollRef = useRef(null);
  const bottomScrollRef = useRef(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const { userProfile } = useContext(AuthContext);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectedRowsCount, setSelectedRowsCount] = useState(0);
  const [epicIdMap, setEpicIdMap] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const { snackbarOpen } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const SHOW_FILTER_SECTION = false;
  const showDeleteButton= false

  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleBulkEditClick = () => {
    if (selectedRowIds.length === 0) {
      snackbarOpen('Please select rows to proceed with Bulk update');
    } else {
      setOpenDialog(true);
    }
    handleMenuClose();
  };

  const [filterOptions, setFilterOptions] = useState([
    { name: 'Base Efforts', options: [] },
    { name: 'Requirement Clarity', options: [] },
    { name: 'Technical Complexity', options: [] },
    { name: 'External Integration', options: [] },
  ]);

  const handleClose = () => setOpenDialog(false);

  const getPermissions = (userProfile, moduleName) => {
    if (!userProfile?.permissions) return [];
    return userProfile.permissions[moduleName] || [];
  };

  const permission = getPermissions(userProfile, MODULE_NAMES.DEAL_TRANSITION_EFFORT_ESTIMATION);

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const DEAL_ID = query.get('id');

  useEffect(() => {
    const updateFilterOptions = async () => {
      setLoading(true);
      const feEfforts = await fetchFEFilterOptions(
        getBaseEffort,
        'BASE',
        true,
        'baseEffort'
      );
      const requirementClarity = await fetchFEFilterOptions(
        getRequirementClarity,
        'CLARITY',
        true,
        'clarityEffort'
      );
      const technicalComplexity = await fetchFEFilterOptions(
        getTechnicalComplexity,
        'TECH',
        true,
        'techEffort'
      );
      const externalIntegration = await fetchFEFilterOptions(
        getExternalIntegration,
        'INTEGRATION',
        true,
        'externalIntegrationEffort'
      );

      setFilterOptions([
        { name: 'FE Efforts', options: feEfforts },
        { name: 'Requirement Clarity', options: requirementClarity },
        { name: 'Technical Complexity', options: technicalComplexity },
        { name: 'External Integration', options: externalIntegration },
      ]);
    };

    updateFilterOptions();
  }, []);

  useEffect(() => {
    fetchData();
    checkMobileView();
  }, []);

  const fetchCalculatedEffort = async (
    feEffortsId,
    requirementClarityId,
    technicalComplexityId,
    externalIntegrationId,
    rowId
  ) => {
    try {
      const response = await UseAxios(
        getCalculatedFeBaseEffort(
          feEffortsId,
          requirementClarityId,
          technicalComplexityId,
          externalIntegrationId
        )
      );
      if (response?.data) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId
              ? {
                  ...row,
                  feEfforts: `${response?.data?.roundedOverallEffort} day(s)`,
                }
              : row
          )
        );
      }
    } catch (error) {
      console.error('Error fetching FE effort:', error);
    }
  };

  const fetchFEFilterOptions = async (apiFunc, type, active, effortName) => {
    try {
      const responseData = await UseAxios(apiFunc(type, active));
      if (responseData.data?.data?.[effortName]) {
        return responseData.data.data?.[effortName].map((item) => ({
          id: item.id,
          value: item.name.toLowerCase(),
          label: item.name,
        }));
      } else {
        console.error('Failed to fetch filter options');
        return [];
      }
    } catch (error) {
      console.error('Error fetching filter options:', error);
      return [];
    }
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const toggleFilterPanel = () => {
    setIsFilterPanelVisible(!isFilterPanelVisible);
  };

  const handleScrollSync = (source) => {
    if (topScrollRef.current && bottomScrollRef.current) {
      if (source === 'top') {
        bottomScrollRef.current.scrollLeft = topScrollRef.current.scrollLeft;
      } else {
        topScrollRef.current.scrollLeft = bottomScrollRef.current.scrollLeft;
      }
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await UseAxios(getFEeffortDetails(DEAL_ID));

      if (response.data.success) {
        let structuredRows = [];

        response.data.data.forEach((epic) => {
          const epicRow = createEpicRow(epic);
          structuredRows.push(epicRow);

          processStories(epic.story, structuredRows);
        });

        setRows([...structuredRows]);
      } else {
        console.error('Error fetching data:', response.data.error);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const processStories = (stories, structuredRows) => {

    stories?.forEach((story) => {
      const storyRow = createStoryRow(story);
      structuredRows.push(storyRow);

      processSubStories(story.subStory, structuredRows);
    });
  };

  const processSubStories = (subStories, structuredRows) => {

    subStories?.forEach((subStory) => {
      const subStoryRow = createSubStoryRow(subStory);
      structuredRows.push(subStoryRow);
    });
  };

  const createEpicRow = (epic) => ({
    id: epic.id,
    type: 'Epic',
    epicStory_dropdown: 'Epic',
    epicStory: epic.name,
    commentsAssumption: epic.comments || '',
    inScope: epic.in_scope === 1,
    feEfforts: epic.fe_effort_day || 0,
    feEffortOverride: epic.fe_effort_override || 0,
  });

  const createStoryRow = (story) => ({
    
    
    id: story.id,
    type: 'Story',
    epicStory_dropdown: 'Story',
    epicStory: story.name || '',
    commentsAssumption: story.comments || '',
    inScope: story.in_scope === 1,
    feEfforts: story.fe_effort_day || 0,
    feEffortOverride: story.fe_effort_override || 0,
    feEffortComplexity: story.fe_effortComplexity?.id ?? story['fe_effortComplexity.id'] ?? '',
    requirementClarity: story.fe_requirementClarity?.id ?? story['fe_requirementClarity.id'] ?? '',
    technicalComplexity: story.fe_technicalComplexity?.id ?? story['fe_technicalComplexity.id'] ?? '',
    externalIntegration: story.fe_externalIntegration?.id ?? story['fe_externalIntegration.id'] ?? '',
    totalApisUsed: Array.isArray(story.total_apis_used) ? story.total_apis_used : [],
    totalApiOverride: story.total_api_override != null ? Number(story.total_api_override) : 0,
  });

  const createSubStoryRow = (subStory) => ({
    id: subStory.id,
    type: 'Sub-Story',
    epicStory_dropdown: 'Sub-Story',
    epicStory: subStory.name,
    commentsAssumption: subStory.comments || '-',
    inScope: subStory.in_scope === 1,
    feEfforts: subStory.fe_effort_day || '-',
    feEffortOverride: subStory.fe_effort_override || '-',
    feEffortComplexity:
      subStory.fe_effortComplexity?.id ??
      subStory['fe_effortComplexity.id'] ??
      '',
    requirementClarity:
      subStory.fe_requirementClarity?.id ??
      subStory['fe_requirementClarity.id'] ??
      '',
    technicalComplexity:
      subStory.fe_technicalComplexity?.id ??
      subStory['fe_technicalComplexity.id'] ??
      '',
    externalIntegration:
      subStory.fe_externalIntegration?.id ??
      subStory['fe_externalIntegration.id'] ??
      '',
    totalApisUsed: Array.isArray(subStory.total_apis_used)
      ? subStory.total_apis_used
      : [],
    totalApiOverride:
      subStory.total_api_override != null
        ? Number(subStory.total_api_override)
        : 0,
  });

const addButton = () => {
  const newRow = {
    type: 'Epic',
    id: uuidv4(),
    epicStory_dropdown: 'Epic',
    epicStory: '',
    commentsAssumption: '',
    inScope: false,
    feEfforts: '',
    feEffortOverride: '',
    isNew: true,
  };

  setRows((prevRows) => [newRow, ...prevRows]);
  setIsEditing((prev) => ({ ...prev, [newRow.id]: true }));
  setEpicIdMap((prevMap) => ({
    ...prevMap,
    [newRow.id]: newRow.id,
  }));
};

const addStory = (id) => {
  const currentRow = rows.find((row) => row.id === id);
  if (!currentRow) return;

  let newType, parentId;

  if (currentRow.type === 'Epic') {
    newType = 'Story';
    parentId = currentRow.id;
  } else if (currentRow.type === 'Story') {
    newType = 'Sub-Story';
    parentId = currentRow.id;
  } else {
    console.error('Invalid parent type for new story');
    return;
  }

  const newRow = {
    id: uuidv4(),
    type: newType,
    parentId,
    epicStory_dropdown: newType,
    epicStory: '',
    commentsAssumption: '',
    inScope: false,
    feEfforts: '',
    feEffortOverride: '',
    totalApisUsed: [],
    totalApiOverride: 0,
    isNew: true,
  };
  const parentIndex = rows.findIndex((row) => row.id === id);
  const newRows = [
    ...rows.slice(0, parentIndex + 1),
    newRow,
    ...rows.slice(parentIndex + 1),
  ];
  setRows(newRows);
  setIsEditing((prev) => ({ ...prev, [newRow.id]: true }));
  setExpandedRows((prev) => [...new Set([...prev, newRow.id])]);
};

const editRow = (id) => {
  setRows((prevRows) =>
    prevRows.map((row) =>
      row.id === id ? { ...row, originalData: { ...row } } : row
    )
  );

  setIsEditing((prev) => ({ ...prev, [id]: true }));

  const rowToEdit = rows.find((row) => row.id === id);

  if (rowToEdit?.epicStory_dropdown === 'Sub-Story' || rowToEdit?.epicStory_dropdown === 'Story') {
    setExpandedRows((prev) => [...new Set([...prev, id])]);
  } else {
    setExpandedRows((prev) => prev.filter((rowId) => rowId !== id));
  }
};

const handleToggleExpand = (id) => {
  setExpandedRows((prev) => {
    if (prev.includes(id)) {
      setIsEditing((prevEditing) => ({ ...prevEditing, [id]: false }));
      return prev.filter((rowId) => rowId !== id);
    } else {
      return [...prev, id];
    }
  });
};

  const handleInputChange = (id, field, value) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );

    if (
      [
        'feEffortComplexity',
        'requirementClarity',
        'technicalComplexity',
        'externalIntegration',
      ].includes(field)
    ) {
      setRows((prevRows) => {
        const updatedRow = prevRows.find((row) => row.id === id);
        if (
          updatedRow.feEffortComplexity &&
          updatedRow.requirementClarity &&
          updatedRow.technicalComplexity &&
          updatedRow.externalIntegration
        ) {
          fetchCalculatedEffort(
            updatedRow.feEffortComplexity,
            updatedRow.requirementClarity,
            updatedRow.technicalComplexity,
            updatedRow.externalIntegration,
            id
          );
        }
        return prevRows;
      });
    }
  };

  const handleCancel = (id) => {
    setRows((prevRows) => {
      const rowToCancel = prevRows.find((row) => row.id === id);

      if (!rowToCancel) return prevRows;

      if (rowToCancel.isNew) {
        const updatedRows = prevRows.filter((row) => row.id !== id);
        return updatedRows;
      } else {
        return prevRows.map((row) =>
          row.id === id ? { ...rowToCancel.originalData } : row
        );
      }
    });

    setIsEditing((prev) => ({ ...prev, [id]: false }));
  };

  const handleSave = async (id) => {
    const rowToSave = rows.find((row) => row.id === id);
    if (rowToSave) {
      try {
        await saveRow(rowToSave);
        setIsEditing((prev) => ({ ...prev, [id]: false }));
        if (rowToSave.epicStory_dropdown === 'Sub-Story' || rowToSave.epicStory_dropdown === 'Story') {
          setExpandedRows((prev) => prev.filter((rowId) => rowId !== id));
        }
      } catch (error) {
        console.error('Error saving row:', error);
        snackbarOpen('Oops! Please try again', 'warning');
      }
    }
  };

  const renderExpandedContent = (id) => {
    const row = rows.find((r) => r.id === id);
    if (!row || (row.epicStory_dropdown !== 'Sub-Story' && row.epicStory_dropdown !== 'Story')) return null;
    return (
      <ExpandedContent
        id={id}
        row={row}
        isEditable={isEditing[row.id]}
        filterOptions={filterOptions}
        handleInputChange={handleInputChange}
        handleIncrement={handleIncrement}
        handleDecrement={handleDecrement}
        handleSave={handleSave}
        handleCancel={handleCancel}
      />
    );
  };

  const handleIncrement = (id, name) => {
    
    const updatedRows = rows.map((row) => {
      if (row.id === id) {
        return {
          ...row,
          [name]: row[name] ? parseInt(row[name], 10) + 1 : 1, // Increment by 1
        };
      }
      return row;
    });
    setRows(updatedRows); // Update state with incremented value
  };

  const handleDecrement = (id, name) => {
    const updatedRows = rows.map((row) => {
      if (row.id === id) {
        const currentValue = parseInt(row[name] || 0, 10);
        return {
          ...row,
          [name]: currentValue > 0 ? currentValue - 1 : 0,
        };
      }
      return row;
    });
    setRows(updatedRows);
  };
  const saveRow = async (row) => {
    const payload = createPayload(row);
    const response = await sendRowData(row, payload);
  
    if (response?.status !== 200) {
      throw new Error(response?.data?.error);
    }
  
    if ((row.type === 'Epic' || row.type === 'Story') && row.isNew) {
      const newParentId = response.data.data.dealFeEffort.id;
      setEpicIdMap((prevMap) => ({
        ...prevMap,
        [row.id]: newParentId,
      }));
      setRows((prevRows) =>
        prevRows.map((r) =>
          r.id === row.id ? { ...r, id: newParentId, isNew: false, parentId: newParentId } : r
        )
      );
    } else if (row.type === 'Sub-Story' && row.isNew) {
      const newSubStoryId = response.data.data.dealFeEffort.id;
      setRows((prevRows) =>
        prevRows.map((r) =>
          r.id === row.id ? { ...r, id: newSubStoryId, isNew: false } : r
        )
      );
    } else {
      updateRowsAfterSave(row);
    }
  
    const action = row.isNew ? 'created' : 'updated';
    const entityType = ['Epic', 'Story', 'Sub-Story'].includes(row.epicStory_dropdown)
      ? row.epicStory_dropdown
      : 'Data';
  
    snackbarOpen(`${entityType} ${action} successfully`, 'success');
  };

  const createPayload = (row) => {
    let payload = {
      deal_id: DEAL_ID,
      name: row.epicStory.trim(),
      type: row.epicStory_dropdown.toUpperCase().replace('-', '_'),
      comments: row.commentsAssumption?.trim() || '',
    };

    if (row.epicStory_dropdown === 'Story' || row.epicStory_dropdown === 'Sub-Story') {
      payload.parent_id = row.parentId;
    }

    if (row.epicStory_dropdown === 'Sub-Story' || row.epicStory_dropdown === 'Story') {
      Object.assign(payload, {
        in_scope: !!row.inScope,
        fe_effort_day: parseInt(row.feEfforts) || 0,
        fe_effort_override: parseInt(row.feEffortOverride) || 0,
        fe_effort_complexity: row.feEffortComplexity || '',
        requirement_clarity: row.requirementClarity || '',
        technical_complexity: row.technicalComplexity || '',
        external_integration: row.externalIntegration || '',
        total_apis_used: Array.isArray(row.totalApisUsed) ? row.totalApisUsed : [],
        total_api_override: parseInt(row.totalApiOverride) || 0,
      });
    }

    return payload;
  };

  const sendRowData = async (row, payload) => {
    try {
      let response;
      if (row.isNew) {
        response = await UseAxios(saveFEeffortDetails(payload));
      } else {
        payload.id = row.id;
        response = await UseAxios(editFEeffortDetails(payload));
      }
      return response;
    } catch (error) {
      console.error('Error in sendRowData:', error);
      throw error;
    }
  };

  const updateRowsAfterSave = (row) => {
    setRows((prevRows) =>
      prevRows.map((r) =>
        r.id === row.id
          ? { ...r, id: row.id, isNew: false, isEditing: false }
          : r
      )
    );
  };



  const handleHeaderCheckboxChange = (event) => {
    const checked = event.target.checked;
    const updatedRowIds = checked
      ? rows
          .filter((row) => row.epicStory_dropdown === 'Story' || row.epicStory_dropdown === 'Sub-Story')
          .map((row) => row.id)
      : [];

    setSelectedRowIds(updatedRowIds);
    setSelectedRowsCount(updatedRowIds.length);
  };

  const handleRowCheckboxChange = (event, rowId) => {
    const checked = event.target.checked;

    setSelectedRowIds((prevSelected) => {
      const updatedSelected = checked
        ? [...prevSelected, rowId] 
        : prevSelected.filter((id) => id !== rowId);

      setSelectedRowsCount(updatedSelected.length);
      return updatedSelected;
    });
  };

  const getEffortText = (row) => {
    if (row.epicStory_dropdown !== 'Sub-Story' && row.epicStory_dropdown !== 'Story') return '-';
  
    const effortValue = row.feEfforts ? String(row.feEfforts) : '0';
    return effortValue.toLowerCase().includes('day') ? effortValue : `${effortValue} Days`;
  };
  
  

  const getBorderRadius = (index, rows, expandedRows, rowId) => {
    if (index === rows.length - 1 && !expandedRows.includes(rowId)) {
      return 8;
    }
    return 0;
  };

  const renderEditableField = (
    isEditing,
    row,
    fieldKey,
    dropdownCondition,
    renderEditable,
    renderNonEditable
  ) => {
    if (isEditing[row.id] && row.epicStory_dropdown !== dropdownCondition) {
      return renderEditable();
    }
    return renderNonEditable();
  };

  const filteredRows = rows.filter((row) =>
    Object.values(row).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <Box>
      {loading ? (
        <Loader />
      ) : (
        <Box sx={{ width: '100%', maxWidth: '95vw' }}>
          <div
            className={`${styles['ScopeFE-search-and-buttons']} ${styles['ScopeFE-headerSection-flex']} ${styles['filteredRows-ScopeFE']}`}
            style={{ padding: '8px 12px' }}
          >
            <div className={styles['ScopeFE-headerSection-main']}>
              <div
                className={`${styles['ScopeFE-search']} ${styles['ScopeFE-headerSection-mainSearchInput']}`}
              >
                <div className={styles['ScopeFE-headerSection-search']}>
                  <img src={MagnifyingGlass} alt="Search" />
                  <input
                    id="ScopeFE-search-input"
                    type="text"
                    placeholder="Search..."
                    className={styles['ScopeFE-headerSection-searchInput']}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              {isMobileView && SHOW_FILTER_SECTION ? (
                <div className={styles['ScopeFE-headerSection-filterMain']}>
                  <button
                    className={styles['ScopeFE-headerSection-filterMain']}
                    onClick={toggleFilterPanel}
                  >
                    <img
                      src={SettingsDropdown}
                      alt="settings"
                      className={styles['ScopeFE-headerSection-settingsIcon']}
                    />
                    <div className={styles['ScopeFE-headerSection-filter']}>
                      Filter
                    </div>
                  </button>
                  {isFilterPanelVisible && (
                    <div
                      className="filter-panel-wrapper"
                      style={{ position: 'absolute', zIndex: 5 }}
                    >
                      <FilterPanel />
                    </div>
                  )}
                </div>
              ) : null}
            </div>

            <div
              className={`${styles['ScopeFE-headerSection-innerMain']} ${styles['ScopeFE-headerSection-innerMain2']}`}
            >
              {selectedRowsCount > 0 ? (
                <div className={styles['issue-selected-button-container']}>
                  <span>{selectedRowsCount} Issues Selected </span>
                  <span className={styles['divider']}>|</span>

                  <button
                    className={`${styles['button']} ${!hasAccess('update') ? styles['disabledButton'] : styles['enabledButton']}`}
                    onClick={() => setOpenDialog(true)}
                    disabled={!hasAccess('update')}
                  >
                    <img src={Dar_Edit} alt="Edit" />
                    <div>Bulk edit</div>
                  </button>

                  {showDeleteButton && (
                    <button className={styles['button']}>
                      <img src={DeleteIcon} alt="Delete" />
                      <div>Delete</div>
                    </button>
                  )}

                  {openDialog && (
                    <BulkUpdate
                      open={openDialog}
                      handleClose={handleClose}
                      selectedIds={selectedRowIds}
                      filterOptions={filterOptions}
                      fetchRows={fetchData}
                      type="FE"
                    />
                  )}
                </div>
              ) : (
                <div
                  className={`${styles['ScopeFE-headerSection-innerMain']} ${styles['ScopeFE-headerSection-innerMain2']}`}
                >
                  {!isMobileView && SHOW_FILTER_SECTION ? (
                    <div className={styles['ScopeFE-headerSection-filterMain']}>
                      <button
                        className={styles['ScopeFE-headerSection-filterMain']}
                        onClick={toggleFilterPanel}
                      >
                        <img
                          src={SettingsDropdown}
                          alt="settings"
                          className={
                            styles['ScopeFE-headerSection-settingsIcon']
                          }
                        />
                        <div className={styles['ScopeFE-headerSection-filter']}>
                          Filter
                        </div>
                      </button>
                      {isFilterPanelVisible && (
                        <div
                          className="filter-panel-wrapper"
                          style={{
                            position: 'absolute',
                            marginTop: 32,
                            zIndex: 5,
                          }}
                        >
                          <FilterPanel />
                        </div>
                      )}
                    </div>
                  ) : null}

                

                  <Button
                    onClick={addButton}
                    className={styles['ScopeFE-addScopeButton']}
                    disabled={!hasAccess('create')}
                    startIcon={<AddIcon />}
                  >
                  Create Epic
                  </Button>
                  <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={handleMenuClick}
                  >
                  <img src={SettingIcon} alt="Settings" />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleMenuClose}
                   
                  >
                    <MenuItem
                      onClick={handleBulkEditClick}
                      className={styles['bulk-edit-button']}
                    >
                      Bulk Edit
                    </MenuItem>
                  </Menu>
                </div>
              )}
            </div>
          </div>
          <div
            className={styles['ScopeFE-container']}
            ref={topScrollRef}
            onScroll={() => handleScrollSync('top')}
          >
            <div className={styles['ScopeFE-cell']}>
              <input
                type="checkbox"
                className={styles['ScopeFE-checkbox']}
                checked={
                  rows.some((row) => row.epicStory_dropdown === 'Story' || row.epicStory_dropdown === 'Sub-Story') &&
                  selectedRowsCount > 0 &&
                  selectedRowsCount ===
                    rows.filter((row) => row.epicStory_dropdown === 'Story' || row.epicStory_dropdown === 'Sub-Story')
                      .length
                }
                onChange={handleHeaderCheckboxChange}
                disabled={
                  !rows.some((row) => row.epicStory_dropdown === 'Story' || row.epicStory_dropdown === 'Sub-Story')
                }
              />
            </div>
            <div className={styles['ScopeFE-header']}>Type</div>
            <div className={styles['ScopeFE-header']}></div> 
            <div className={styles['ScopeFE-epic']}>Task Name</div>
            <div className={styles['ScopeFE-comments']}>
              Comments/Assumption
            </div>
            <div className={styles['ScopeFE-inScope']}>In scope?</div>
            <div className={styles['ScopeFE-feEfforts']}>Base Efforts</div>
            <div className={styles['ScopeFE-effortOverride']}>
             Base Effort Override
            </div>
            <div className={styles['ScopeFE-actions']}></div>
          </div>
          {filteredRows.length > 0 ? (
            <Box
              ref={bottomScrollRef}
              onScroll={() => handleScrollSync('bottom')}
              className={styles.bottomScrollContainer}
            >
              {filteredRows.map((row, index) => (
                <React.Fragment key={row.id}>
                  <Box
                    className={`
                      ${styles.rowContainer} 
                      ${expandedRows.includes(row.id) ? styles.expanded : ''} 
                      ${
                        getBorderRadius(index, rows, expandedRows, row.id)
                          ? styles.lastRow
                          : ''
                      }
                    `}
                  >
                    <Box sx={{ flex: 1, textAlign: 'center', minWidth: 80 }}>
                      <input
                        type="checkbox"
                        className={styles['ScopeFE-checkbox']}
                        checked={selectedRowIds.includes(row.id)}
                        onChange={(e) => handleRowCheckboxChange(e, row.id)}
                        disabled={row.epicStory_dropdown !== 'Story' && row.epicStory_dropdown !== 'Sub-Story'}
                      />
                    </Box>
                    <Box
                      className={`${styles.boxCommonStyle} ${styles.boxFlex1}`}
                      style={{ minWidth: 80 }}
                    >
                      {getTypeIcon(row.epicStory_dropdown)}
                    </Box>
                    <Box
                      className={`${styles.boxCommonStyle} ${styles.boxFlex1}`}
                      style={{ minWidth: 90, position: 'relative' }}
                    >
                      {row.epicStory_dropdown !== 'Sub-Story' && (
                        <div className={styles['buttons-wrapper']}>
                          <button
                            className={styles['add-button']}
                            onClick={() => addStory(row.id)}
                          >
                            +
                          </button>
            
                        </div>
                      )}
                    </Box>
                    <Box className={styles.epicStoryContainer}>
                      {isEditing[row.id] ? (
                     
                          <TextField
                            value={row.epicStory}
                            onChange={(e) =>
                              handleInputChange(
                                row.id,
                                'epicStory',
                                e.target.value
                              )
                            }
                            size="small"
                            className={styles.textFieldBorderlessCompact}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                  borderColor: '#CAC4CF !important',
                                },
                                '&:hover fieldset': {
                                  borderColor: '#CAC4CF !important',
                                },
                                '&.Mui-focused fieldset': {
                                  borderColor: '#CAC4CF !important',
                                },
                              },
                            }}
                          />
                       
                      ) : (
                        <div className={styles['epic-story-container']}>
                          <span className={styles['saved-value']}>
                            {row.epicStory || '-'}
                          </span>
                        </div>
                      )}
                    </Box>
                    <Box
                      className={`${styles.boxCommonStyle} ${styles.boxFlex4}`}
                      style={{ minWidth: 150 }}
                    >
                      {isEditing[row.id] ? (
                        <TextField
                          value={row.commentsAssumption}
                          onChange={(e) =>
                            handleInputChange(
                              row.id,
                              'commentsAssumption',
                              e.target.value
                            )
                          }
                          className={styles.commentsInputField}
                          sx={{
                            width: '100%',
                            margin: '0px 8px',
                             }}
                          variant="outlined"
                          size="small"
                        />
                      ) : (
                        <div className={styles['saved-value']}>
                          {row.commentsAssumption || '-'}
                        </div>
                      )}
                    </Box>
                    <Box
                      className={`${styles.boxCommonStyle} ${styles.boxFlex2}`}
                    >
                      {renderEditableField(
                        isEditing,
                        row,
                        'inScope',
                        'Epic',
                        () => (
                          <input
                            type="checkbox"
                            className={styles['ScopeFE-checkbox']}
                            checked={row.inScope}
                            onChange={(e) =>
                              handleInputChange(
                                row.id,
                                'inScope',
                                e.target.checked
                              )
                            }
                          />
                        ),
                        () => (
                          <div>
                            {row.epicStory_dropdown !== 'Epic' ? (
                              <input
                                type="checkbox"
                                className={styles['ScopeFE-checkbox']}
                                checked={row.inScope}
                                disabled
                                style={{
                                  opacity: 0.5,
                                  pointerEvents: 'none',
                                  cursor: 'default',
                                }}
                                onChange={(e) =>
                                  handleInputChange(
                                    row.id,
                                    'inScope',
                                    e.target.checked
                                  )
                                }
                              />
                            ) : (
                              ''
                            )}
                          </div>
                        )
                      )}
                    </Box>

                    <Box
                      className={`${styles.boxCommonStyle} ${styles.boxFlex2}`}
                    >
                      <div className={styles['saved-value']}>
                        {getEffortText(row)}
                      </div>
                    </Box>
                    <Box
                      className={`${styles.boxCommonStyle} ${styles.boxFlex2}`}
                    >
                      {isEditing[row.id] &&
                      row.epicStory_dropdown !== 'Epic' ? (
                        <OutlinedInput
                          value={row.feEffortOverride || '0'}
                          onChange={(e) =>
                            handleInputChange(
                              row.id,
                              'feEffortOverride',
                              e.target.value
                            )
                          }
                          type="number"
                          startAdornment={
                            <InputAdornment position="start">
                              <IconButton
                                onClick={() =>
                                  handleDecrement(row.id, 'feEffortOverride')
                                }
                                size="small"
                                sx={{ padding: 0 }}
                              >
                                <RemoveIcon
                                  fontSize="small"
                                  sx={{ fontSize: '14px' }}
                                />
                              </IconButton>
                            </InputAdornment>
                          }
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() =>
                                  handleIncrement(row.id, 'feEffortOverride')
                                }
                                size="small"
                                sx={{ padding: 0 }}
                              >
                                <AddIcon
                                  fontSize="small"
                                  sx={{ fontSize: '14px' }}
                                />
                              </IconButton>
                            </InputAdornment>
                          }
                          inputProps={{ style: { textAlign: 'center' } }}
                          className={styles.feEffortOverrideInput}
                        />
                      ) : (
                        <div className={styles['saved-value']}>
                          {row.feEffortOverride
                            ? `${row.feEffortOverride} Days`
                            : ''}
                        </div>
                      )}
                    </Box>
                    <Box className={`${styles.boxCommonStyle} ${styles.boxFlex1}`}>
  <div className={`${styles['edit-expand-buttons']} ${styles['button-container']}`}>
    {row.epicStory_dropdown !== 'Epic' ? (
      <ExpandButton
        id={row.id}
        expanded={expandedRows.includes(row.id)}
        onToggleExpand={handleToggleExpand}
      />
    ) : (
      <div className={styles['expand-placeholder']}></div>
    )}
    {!isEditing[row.id] && ( 
      <button
        className={`${styles['ScopeFE-editButton-scopeAdded']} ${!hasAccess('update') ? styles['disabledButton'] : styles['enabledButton']}`}
        onClick={() => editRow(row.id)}
        disabled={!hasAccess('update')}
      >
        <img src={Dar_Edit} alt="edit" />
      </button>
    )}
  </div>
</Box>
                    {isEditing[row.id] && row.epicStory_dropdown === 'Epic' && (
                      <Box
                        className={`${styles.boxCommonStyle} ${styles.boxFlex1}`}
                        sx={{ marginTop: '30px' }} // Add margin-top for Epic
                      >
                        <div
                          style={{
                            display: 'flex',
                            gap: '8px',
                            justifyContent: 'center',
                          }}
                        >
                          <Button
                            variant="contained"
                            size="small"
                            onClick={() => handleSave(row.id)}
                            className={styles.saveButtonStyle}
                            startIcon={<CheckIcon />}
                          />
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() => handleCancel(row.id)}
                            className={styles.cancelButtonStyle}
                            startIcon={<ClearIcon />}
                          />
                        </div>
                      </Box>
                    )}
                  </Box>
                  {expandedRows.includes(row.id) &&
                    renderExpandedContent(row.id)}
                </React.Fragment>
              ))}
            </Box>
          ) : (
            <div className={styles['ScopeFE-noFileContainer']}>
              <img src={Dar_noFile} alt="No file available" />
              <div className={styles['ScopeFE-noFileText']}>
                “No Epics/Stories Have Been Created Yet.”
              </div>
              <div className={styles['ScopeFE-noFileSubtext']}>
                Please add an Epic/Story to view here
              </div>
            </div>
          )}
        </Box>
      )}
    </Box>
  );
}

ExpandButton.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggleExpand: PropTypes.func.isRequired,
};
